import { Input } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import Icon from '@/components/Icon';
import styles from './index.less';

const PLACEHOLDER = '请搜索您想要的…';

// 定义props传输的参数类型
type SearchProps = {
  activeId: string;
  value: string;
  onClickClose: () => void;
  onClickSearch: (item: object) => void;
  setRecentSearchList: (value: string) => void;
};

// 定义searchbox组件
const SearchBar = ({
  value = '',
  activeId,
  onClickSearch = ({}) => {},
  onClickClose = () => {},
  setRecentSearchList = () => {},
}: SearchProps) => {
  const newProps = { value }; // 定义新对象
  const [currentId] = useState(activeId); // 选择下拉active
  const [inputVal, setInputVal] = useState(''); // input输入内容
  const [list, setList] = useState([]);

  // 搜索方法
  const onSearch = () => {
    const item = {
      typeId: currentId,
      searchKey: inputVal,
    };
    if (onClickSearch) {
      onClickSearch(item);
    }
  };

  // 设置默认选中下拉状态
  useEffect(() => {
    if (newProps.value) {
      setInputVal(newProps.value);
      onSearch();
    }
  }, [newProps.value]);

  // 输入框输入
  const onChange = (e: any) => {
    setInputVal(e.target.value);
    setList(list.concat(e.target.value));
  };
  const onSearchPage = () => {
    if (inputVal) {
      setRecentSearchList(inputVal);
      window.open(
        `/category?keyword=${encodeURIComponent(inputVal)}`,
        '_blank',
      );
    }
  };
  // 回车键执行搜索
  const onKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      onSearch();
      onSearchPage();
    }
  };
  const onClear = () => {
    setInputVal('');
  };
  // 搜索框结构
  return (
    <div
      className={classNames(
        styles.warp,
        'w-[1226px] mx-auto mt-[16px] relative',
      )}
    >
      <Input
        autoFocus
        type="text"
        maxLength={30}
        value={inputVal}
        onChange={onChange}
        onKeyDown={onKeyDown}
        aria-invalid="false"
        aria-required="false"
        placeholder={PLACEHOLDER}
        prefix={
          <Icon
            type="icon-iocn_search"
            className="text-[20px] text-[#111111] mr-[20px]"
          />
        } // 前缀图标
        className="w-[100%] h-[48px] bg-[#fafafa] py-[13px] px-[24px] text-[#999999] text-[16px] leading-[22px] border-none"
      />
      <div className="absolute right-[-32px] top-[15px] cursor-pointer">
        <div
          onClick={() => {
            onClear();
            onClickClose();
          }}
        >
          <Icon type="icon-a-icon_guanbi2" className="text-[18px]" />
        </div>
        {/* <div
          onClick={() => {
            onSearch();
            onSearchPage();
          }}
        >
          <Icon type="icon-a-icon_guanbi2" className="text-[18px]" />
        </div> */}
      </div>
    </div>
  );
};

export default SearchBar;
